export default __webpack_public_path__ + "static/5_24-33f1c2c343840759af2f2b2b718debd1.png";